import { jwtDecode } from "jwt-decode";

import { UserData } from "../constants/types";

export function parseToken(token: string): UserData {
  const { user, exp } = jwtDecode<{ user?: UserData; exp?: number }>(token);
  if (!user || !exp || Date.now() >= exp * 1000) {
    throw new Error("Invalid or expired token");
  }
  return user;
}
